export enum REMEMBER_ME_COOKIES_SECTION {
    username = 0, 
    selector = 1, 
    validator = 2
  }